import moment from "dayjs"
import { FilterItemProps } from "../filter/interface"
export const BillModes = ["仅允许线上支付", "仅允许挂帐", "挂账+支付", "不限制"];

export const StatusList: { title: string, key: number }[] = [
  {
    title: "人保取消",
    key: 14,
  },
]

export const StatusNumList: { title: string, key: number }[] = [
  {
    title: "全部",
    key: -1,
  }, {
    title: "已完成",
    key: 1,
  }, {
    title: "未完成",
    key: 2,
  }
]

export const ModeList: { title: string, key: number }[] = [
  {
    title: "全部",
    key: -1,
  },
  {
    title: "事故救援",
    key: 0,
  },
  {
    title: "非事故救援",
    key: 1,
  }]


export const NoneItemsList: { title: string, key: number }[] = [
  {
    title: "空单",
    key: 0,
  },
  {
    title: "非空单",
    key: 1,
  }]

export const PayStatus: { title: string, key: number }[] = [
  {
    title: "未支付",
    key: 1,
  },
  {
    title: "已支付",
    key: 2,
  },
  {
    title: "未挂账",
    key: 3,
  },
  {
    title: "已挂帐",
    key: 4,
  },
  {
    title: "未支付且已挂帐",
    key: 5,
  },
  {
    title: "未支付且未挂帐",
    key: 6,
  },
  {
    title: "已支付且已挂帐",
    key: 7,
  },
  {
    title: "已支付且未挂帐",
    key: 8
  },
]

// 回单状态
export const FeedbackStatusList: { title: string, key: number }[] = [
  {
    title: "全部",
    key: -1,
  },
  {
    title: "已审核",
    key: 1,
  },
  {
    title: "未审核",
    key: 0,
  }]

// 结算状态
export const CheckOutList: { title: string, key: number }[] = [
  {
    title: "未结算",
    key: 0,
  },
  {
    title: "已结算",
    key: 1,
  }]

// 拖车侠企业ID
const TCX_ID = 19;

// 搜索表单配置
export const filterItems: FilterItemProps[] = [
  {
    label: "报案号",
    type: "text",
    name: "registNo",
    col: 6,
  }, {
    label: "车牌号",
    type: "text",
    name: "license",
    col: 6,
  }, {
    label: "客户电话",
    type: "text",
    name: "phone",
    col: 6,
  },
  /* {
    label: "救援服务公司",
    type: "select",
    name: "driverCompany",
    col: 6,
    options: [
      {
        label: "拖车侠",
        value: TCX_ID,
      },
      {
        label: "联盟",
        value: -TCX_ID,
      }]
  },  */
  // {
  //   label: "支付模式",
  //   type: "select",
  //   name: "billmode",
  //   col: 6,
  //   options: BillModes.map((it, index) => ({ label: it, value: index })).slice(0, 3)
  // },
];


export function getDiffTime(time: number) {

  let diff = moment().diff(moment(time * 1000), 'm');

  let diffTime = diff + "分"
  if (diff > 60 * 24 * 365) {
    diffTime = moment().diff(moment(time * 1000), 'y') + "年"
  }
  else if (diff > 60 * 24 * 30) {
    diffTime = moment().diff(moment(time * 1000), 'm') + "月"
  }
  else if (diff > 60 * 24) {
    diffTime = Math.ceil(diff / 60 / 24) + "天"
  } else if (diff > 60) {
    diffTime = Math.ceil(diff / 60) + "小时"
  }
  return { diffTime, diffminute: diff }
}

export function getPayStatusParam(status: number) {
  let where: string = ''

  switch (status) {
    case 1:
      where = `payFilter=0`
      break;
    case 2:
      where = `payFilter=1`
      break;
    case 3:
      where = `creditFilter=0`
      break;
    case 4:
      where = `creditFilter=1`
      break;
    case 5://未支付且已挂帐
      where = `payFilter=0&creditFilter=1`
      break;
    case 6://未支付且未挂帐
      where = `payFilter=0&creditFilter=0`
      break;
    case 7://已支付且已挂帐
      where = `payFilter=1&creditFilter=1`
      break;
    case 8://已支付且未挂帐
      where = `payFilter=1&creditFilter=0`
      break;
  }
  return where
}